/* global dataLayer */
define("dataLayer", [], function (
) {
    return dataLayer;
});